import React, { useState, useEffect } from 'react';

const EmailIndex = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const token = document.querySelector("[name='csrf-token']").content;
    const [form, setForm] = useState({ 
        email: ""
    });

    const [messageContent, setMessageContent] = useState({ 
        valid: true,
        message: "El correo electrónico o la contraseña ingresados son inválidos. Por favor, verifica tus datos e intenta nuevamente."
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleSubmit = e => {
        e.preventDefault();
    };

    const validationForm = () => {
        if (form.email != ""
        ) {
            setMessageContent({ ...messageContent, valid: true })
            return true
        }else{
            setMessageContent({ messageContent, valid: false, message: "El campo de correo electrónico es obligatorio. Por favor, ingresa una dirección de email válida" })
            return false
        }
    }

    const handleClick = () => {
        if(validationForm()){
            setIsLoaded(true);

            fetch(`/api/v1/validate_user_email`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": token,
                    "authorization": "98a2425c7cd22d4dad50",
                    "Content-Type": "application/json"
                }
            })
    
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                console.log("data", data);
                
                if(data.data.valid){ 
                    setIsLoaded(false);
                    setMessageContent(data.data);
                    props.toogleSetUser(data.register);
                    props.toogleTab("user")
                }else{
                    setIsLoaded(false);
                    setMessageContent(data.data)
                }
            });
        }
    }

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <label>Correo electrónico </label> <span className="text-danger">*</span><br />
                        <input 
                            type="email" 
                            name="email"
                            className={`form form-control ${!messageContent.valid && form.email == "" ? "error-class" : ""}`}
                            disabled={isLoaded}
                            value={form.email}
                            onChange={handleChange}
                        />
                    </div>

                    {!messageContent.valid && (
                        <div className="col-md-12 mt-3">
                            <div className="alert alert-danger text-center text-white" role="alert">
                                {messageContent.message}
                            </div>
                        </div>    
                    )}

                    <div className="col-md-12">
                        <hr />
                    </div>

                    <div className="col-md-12">
                        <div className="alert alert-primary text-white text-center" role="alert">
                            Una vez ingreses tu dirección de correo electrónico, te enviaremos las instrucciones para restablecer tu contraseña. Si no encuentras el correo, verifica en tu carpeta de spam o correo no deseado
                        </div>
                    </div>

                    <div className="col-md-12 text-center">
                        <button
                            className='btn btn-primary text-white mr-2'
                            onClick={handleClick}
                            disabled={isLoaded}
                        >
                            {isLoaded ? "Cargando..." : "Continuar"}
                        </button>

                        <button
                            className='btn btn-light text-black'
                            onClick={() => props.toggle()}
                        >
                            Cerrar
                        </button>
                    </div>

                </div>
            </form>
        </React.Fragment>
    );
}


export default EmailIndex;

